import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/arsiv")({
  beforeLoad: () => {
    throw redirect({ to: "/yazilar", statusCode: 301 });
  },
  component: () => null,
});
